export default "__VITE_ASSET__cce56e0a__"